import { Alert } from '@mui/material'
import { FormDialog } from 'components/dialog/form'
import { useSearchForm, SearchForm } from '../form/searchForm'

import { SearchResult, usePostSearch } from 'interface/search'

type EntrySearchDialogProps = {
  onSubmit: (result: SearchResult) => void
  onClose: () => void
}
export const EntrySearchDialog = ({
  onSubmit,
  onClose
}: EntrySearchDialogProps) => {
  const form = useSearchForm()
  const {
    form: {
      formState: { isValid },
      handleSubmit
    }
  } = form
  const [postState, submit] = usePostSearch({ onPosted: onSubmit })

  return (
    <FormDialog
      open
      fullWidth
      maxWidth="sm"
      title="分析依頼を登録"
      note={
        <Alert severity="info">
          新たに分析依頼を登録します。
        </Alert>
      }
      encType="multipart/form-data"
      isLoading={postState.posting || form.isLoading}
      error={postState.error}
      body={<SearchForm {...form}/>}
      submitLabel="依 頼 登 録"
      isValid={isValid}
      onSubmit={handleSubmit(submit)}
      onClose={onClose}
    />
  )
}
